module.exports = __webpack_public_path__ + "img/add_btn.c50ae3f7.png";